/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { Link } from 'react-router-dom';
import { Text } from '@blend/enterprise-components';
import { TypeaheadResultComponent } from '../../TypeaheadSearch/TypeaheadResults';
import { removeDefaultAnchorStyling } from 'blb-styles/mixins';

const styles = StyleSheet.create({
  result: {
    display: 'inline-block',
    minHeight: 100,
    padding: '16px 24px',
    width: '100%',
    ...removeDefaultAnchorStyling(),
  },
});

export namespace PipelineSearchResult {
  export type Props = TypeaheadResultComponent.Props;
}

export const PipelineSearchResult: React.FC<PipelineSearchResult.Props> = ({
  result: { loanId, loanRefNumber, primaryBorrowerName, propertyAddress },
}) => (
  <Link className={css(styles.result)} to={`${loanId}/dashboard`}>
    <Text displayBlock={true} weight="semibold">
      {primaryBorrowerName}
    </Text>
    <Text displayBlock={true} fontSize="sm">
      #{loanRefNumber}
    </Text>
    {propertyAddress && (
      <Text displayBlock={true} fontSize="sm">
        {propertyAddress}
      </Text>
    )}
  </Link>
);
